import React, { Component } from 'react';

import { ProgressBar } from 'react-bootstrap';
import './score-bars.css';


import blankImage from '../../Common/blank-512x366.png'

export class PlayerScoreBar extends Component {

    render() {
        let gamePlayerData = this.props.gamePlayerData;
        if (!gamePlayerData) {
            return <></>;
        }
        const VARIANTS = [
            null, 'deep', 'stem', 'hex', 'dread', 'honored', 'seed'
        ];
        let variant = VARIANTS[gamePlayerData.faction];
        let fadedVariant = variant + '-faded';
        let className = 'bg-' + variant + '-faded';
        let currentScore = gamePlayerData.current_score;
        let currentRoundPoints = gamePlayerData.current_round_points;
        // currentScore = Math.floor(Math.random() * 24);
        // currentRoundPoints = Math.floor(Math.random() * 6);

        // currentScore = 1;
        // currentRoundPoints = 10;

        let now1 = currentRoundPoints;
        let now2 = currentScore - currentRoundPoints;
        if (now2 < 0) now2 = 0;
        let now3 = 20 - (now1 + now2);
        if (now3 < 0) now3 = 0;
        let now4 = 24 - (now1 + now2 + now3);

        let label = gamePlayerData.name + ' : ' + currentScore;
        if (this.props.isActive) label += '*'

        let label3 = (currentScore < 10) ? label : '';
        let label2 = (label3 === '') ? label : '';

        if (now4 + now3 + now2 + now1 !== 24) {
            console.error('nope');
        }

        // let height = this.props.height ? this.props.height : '1.4rem';

        return (<div className={'observer-bar-wrapper'}>
            <ProgressBar
                style={{ backgroundColor: 'transparent', height: '100%' }}
            >
            <ProgressBar variant={VARIANTS[gamePlayerData.faction]}
                         min={0}
                         max={24}
                         now={now2}
                         key={1}
                         label={label2}
            />
            <ProgressBar className={className + ' progress-bar-striped-upright'}
                         min={0}
                         max={24}
                         now={now1}
                         key={2}
                         label={now1}
                         striped
                         animated
            />
            <ProgressBar className={className}
                         min={0}
                         max={24}
                         now={now3}
                         key={3}
                         label={label3}
            />
                {currentScore > 19 &&
            <ProgressBar variant={'danger'}
                         min={0}
                         max={24}
                         now={now4}
                         key={4}
                         // striped
                         animated
            />
                }
            </ProgressBar>
            </div>
        );
    }
}


export default class HotelObserverScoreBars extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }


    render() {
        let gameData = this.props.gameData;
        if (!gameData) {
            return <></>;
        }

        let gamePlayers = gameData.gameplayer_set;
        let activePlayer = gameData.active_player;

        return (
            <div className={'observer-score-bars'}>
                {gamePlayers.map((gamePlayerData, key) => {
                    return <PlayerScoreBar
                        key={key}
                        gamePlayerData={gamePlayerData}
                        isActive={activePlayer === gamePlayerData.id}
                    />
                })}
            </div>
        );
    }
}
